import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as api from '../../../api';
import { Grid} from 'semantic-ui-react';
import UserManagementFilterableDatatable from "../../../components/table/user-management-filterable-data-table";
import 'semantic-ui-css/semantic.min.css';
import UserTableHeader from "./user-table-header";
import UserTableRow from "./user-table-row";
import ApiDataProvider from "../../../components/table/data-providers/api-data-provider";
import { Helmet } from 'react-helmet'
import AddUserModal from './add-user-modal'
import {AuthService} from "../../../services/auth-service";


function mapStateToProps(state) {
    return {

    };
}

class manageusers extends Component {

    constructor(props) {
        super(props);
        this.authServices = new AuthService();


        this.state = {
            dataProvider: new ApiDataProvider(api.getCustomerUserList, [this.props.customerId]),
            rolesList: [],//new ApiDataProvider(api.getRolesList, [this.props.customerId]),
            userList: [],
            isDataEdited: false,
            isAdmin: false // Default to false until the check is complete

        };

        this.fetchData();
    }

    componentDidMount() {
       
                  // Check if the user is an admin
                  this.checkAdminStatus();
      }
    
    
    
      checkAdminStatus = async () => {
        const isAdmin = await this.authServices.isUserAdmin();
        this.setState({ isAdmin });
    };

    getStoreageRule() {
        try {
           
            return this.props.location.state.clearStore; // better way to check undefined but i'm going mad today
        } catch
        {
            return false
        }
    }

    componentDidUpdate() {
        if (this.state.isDataEdited) {
            this.fetchData();
            this.setState({ isDataEdited: false })
        }
    }

    fetchData() {

        api.getCustomerUserList(this.props.customerId)
            .then(data => {

                this.setState({ userList: data });
          
               



            }).catch(function (error) {
                // Acquire token interactive failure
                console.log(error);
            });


            api.getRolesList(this.props.customerId)
            .then(data => {
                this.setState({ rolesList: data });
            }).catch(function (error) {
                // Acquire token interactive failure
                console.log(error);
            });




    }
    

    notifyParent = () => {
        window.location.reload(false);


    }

    render() {
        return (
            <div className='main-container'>
                <Helmet>
                    <title>Inenco Portal | Users</title>
                </Helmet>
                {this.state.isAdmin && 
                <Grid padded stackable columns='equal'>
                    <Grid.Row>
                        <Grid.Column>
                            <h2>User Management</h2>
                        </Grid.Column>
                        <Grid.Column>
                            <AddUserModal customerId={this.props.customerId} notifyParent={this.notifyParent}  />
                        </Grid.Column>
                    </Grid.Row>

                    <Grid.Row>
                        <Grid.Column>
                            <div className="table-container">
                                <UserManagementFilterableDatatable dataProvider={this.state.dataProvider} name="Users" canExport={false} storeName="userList" 
                                    contextData={{ customerId: this.props.customerId }} defaultSort={"userName"} rolesList={this.state.rolesList}
                                    headerComponent={UserTableHeader} rowComponent={UserTableRow} />
                            </div>
                        </Grid.Column>

                    </Grid.Row>
                </Grid>
            }
            </div>
        );
    }
}

export default connect(
    mapStateToProps,
)(manageusers);